import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncablePriceListRevenueDepartmentFragment = { readonly __typename?: 'SyncablePriceListRevenueDepartment', readonly id: string, readonly name: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncPriceListRevenueDepartmentPullQueryVariables = Types.Exact<{
  input: Types.PullPriceListRevenueDepartmentInput;
}>;


export type SyncPriceListRevenueDepartmentPullQuery = { readonly __typename?: 'Query', readonly pullPriceListRevenueDepartment: { readonly __typename?: 'PullPriceListRevenueDepartmentResult', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncablePriceListRevenueDepartment', readonly id: string, readonly name: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncablePriceListRevenueDepartmentFragmentDoc = gql`
    fragment WholeSyncablePriceListRevenueDepartment on SyncablePriceListRevenueDepartment {
  id
  name
  meta {
    createdAt
    createdByUserId
    updatedAt
    updatedByUserId
    deleted
  }
}
    `;
export const SyncPriceListRevenueDepartmentPullDocument = gql`
    query SyncPriceListRevenueDepartmentPull($input: PullPriceListRevenueDepartmentInput!) {
  pullPriceListRevenueDepartment(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncablePriceListRevenueDepartment
    }
  }
}
    ${WholeSyncablePriceListRevenueDepartmentFragmentDoc}`;

/**
 * __useSyncPriceListRevenueDepartmentPullQuery__
 *
 * To run a query within a React component, call `useSyncPriceListRevenueDepartmentPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncPriceListRevenueDepartmentPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncPriceListRevenueDepartmentPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncPriceListRevenueDepartmentPullQuery(baseOptions: Apollo.QueryHookOptions<SyncPriceListRevenueDepartmentPullQuery, SyncPriceListRevenueDepartmentPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncPriceListRevenueDepartmentPullQuery, SyncPriceListRevenueDepartmentPullQueryVariables>(SyncPriceListRevenueDepartmentPullDocument, options);
      }
export function useSyncPriceListRevenueDepartmentPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncPriceListRevenueDepartmentPullQuery, SyncPriceListRevenueDepartmentPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncPriceListRevenueDepartmentPullQuery, SyncPriceListRevenueDepartmentPullQueryVariables>(SyncPriceListRevenueDepartmentPullDocument, options);
        }
export type SyncPriceListRevenueDepartmentPullQueryHookResult = ReturnType<typeof useSyncPriceListRevenueDepartmentPullQuery>;
export type SyncPriceListRevenueDepartmentPullLazyQueryHookResult = ReturnType<typeof useSyncPriceListRevenueDepartmentPullLazyQuery>;
export type SyncPriceListRevenueDepartmentPullQueryResult = Apollo.QueryResult<SyncPriceListRevenueDepartmentPullQuery, SyncPriceListRevenueDepartmentPullQueryVariables>;